var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row form-group" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(
              _vm._s(_vm.resource("JourneyBuilder_TimerSettings_Frequency"))
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row form-group" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("settings-property", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function(ref) {
                    var id = ref.id
                    return [
                      _c("label", { attrs: { for: id } }, [
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_TimerSettings_Frequency_Unit_Label"
                            )
                          )
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "input",
                  fn: function(ref) {
                    var id = ref.id
                    return [
                      _c("v-select", {
                        staticClass: "form-control",
                        attrs: {
                          options: _vm.UNIT_OPTIONS,
                          disabled: !_vm.canWrite,
                          clearable: false,
                          "input-id": id,
                          searchable: "",
                          filterable: ""
                        },
                        model: {
                          value: _vm.unitModel,
                          callback: function($$v) {
                            _vm.unitModel = $$v
                          },
                          expression: "unitModel"
                        }
                      })
                    ]
                  }
                },
                {
                  key: "errors",
                  fn: function() {
                    return [
                      _vm.$v.$dirty && _vm.$v.unit.$invalid
                        ? _c("required-error-message")
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.unitModel
        ? [
            _c("div", { staticClass: "row form-group" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("settings-property", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function(ref) {
                            var id = ref.id
                            return [
                              _c("label", { attrs: { for: id } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.resource(
                                      "JourneyBuilder_TimerSettings_Frequency_Recurrence_Label"
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "input",
                          fn: function(ref) {
                            var id = ref.id
                            return [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-8" },
                                  [
                                    _c("v-select", {
                                      staticClass: "form-control",
                                      attrs: {
                                        options:
                                          _vm.unitModel.recurrenceOptions,
                                        disabled: !_vm.canWrite,
                                        clearable: false,
                                        "input-id": id,
                                        searchable: "",
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.recursInUnitModel,
                                        callback: function($$v) {
                                          _vm.recursInUnitModel = $$v
                                        },
                                        expression: "recursInUnitModel"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-4" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.unitModel.recurrenceLabel) +
                                      "\n                            "
                                  )
                                ])
                              ])
                            ]
                          }
                        },
                        {
                          key: "errors",
                          fn: function() {
                            return [
                              _vm.$v.$dirty && _vm.$v.recursInDays.$invalid
                                ? _c("required-error-message")
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3602487104
                    )
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.unitModel === _vm.UNITS.WEEKLY
        ? [
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-2" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "JourneyBuilder_TimerSettings_Frequency_Weekday_Label"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.WEEKDAY_OPTIONS, function(weekday) {
                    return _c("div", { staticClass: "col-4" }, [
                      _c("input", {
                        attrs: {
                          type: "checkbox",
                          id: "weekday_" + weekday.id,
                          disabled: !_vm.canWrite
                        },
                        domProps: {
                          checked: _vm.weekdays.includes(weekday.id)
                        },
                        on: {
                          input: function($event) {
                            return _vm.toggleWeekday(weekday)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "weekday_" + weekday.id } }, [
                        _vm._v(_vm._s(weekday.label))
                      ])
                    ])
                  }),
                  0
                )
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }